export const PREFIX_MODEL_FILE_INFO = "File_Info_";
export const RADIO_OTHER_OPTIONS_PREFIX = "|:::|other|:::|";


// WEBPACK FOOTER //
// ./src/constants/prefix.js